export {data};

import {redirect, render} from 'vike/abort';
import API_URL from '../../includes/api.js';
import {resolveTenantData} from '../../tenant/site-configs.js';
import {fetchApiJson, refererHeaders} from '../../includes/server-fetch.js';
import {mainSiteUrl} from '../../../tenant.config.js';
import {pickRandom} from '../../utils/pickRandom.js';

const PLAYLISTS_SHOWN = 6;

// Mirrors HomeSub.jsx's fetch so <Helmet>/hero aren't empty before client hydration.
// Vike's +data.shared.js isn't cumulative — must resolve+spread tenant data here or this page loses messages/faq/about.
async function data(pageContext) {
    const tenantData = resolveTenantData(pageContext);
    const subdomain = pageContext.subdomain ?? '';
    if (!subdomain) return {...tenantData, subscriber: null};

    const result = await fetchApiJson(`${API_URL}/subscriber/getinfo?domain_name=${encodeURIComponent(subdomain)}`, refererHeaders(pageContext), pageContext);

    // Redirect only on a definitive "not live" answer (unknown or confirmed
    // disabled); a network failure or transient API error (429, 500, ...)
    // isn't a reason to banish a live subscriber's visitors, so it forwards
    // as that same status instead via render() below.
    if (result.code === 404) {
        throw redirect(mainSiteUrl(pageContext.hostname));
    }
    if (result.ok && result.data?.data?.enabled !== 'yes') {
        throw redirect(mainSiteUrl(pageContext.hostname));
    }
    if (result.code !== null && !result.ok) {
        throw render(result.code);
    }

    const subscriber = result.ok ? result.data : null;

    // Choose the six playlists here, once. The page used to shuffle during
    // render, so the server HTML had one order and the hydrating client
    // another; Preact leaves attributes alone while hydrating but patches
    // text, leaving every card titled for a different playlist than its link
    // and thumbnail. Shuffling before the data is serialised means both
    // renders see the same six in the same order.
    return {
        ...tenantData,
        subscriber: subscriber
            ? {...subscriber, playlists: pickRandom(subscriber.playlists, PLAYLISTS_SHOWN)}
            : null,
    };
}
